export const formatCoordinate = (coordinate: number) => coordinate.toPrecision(3);